import cx from 'classnames';
import React from 'react';
import { Button } from '../../button';
import { IconID } from '../../icon';
import { generatePages } from '../page-generator-service';
import styles from './pagination-numbers.module.scss';
export const PaginationNumbers = ({ activePage, totalPages, onActivePageChange, }) => {
    const pages = generatePages(activePage, totalPages);
    const ELLIPSIS = '...';
    return (React.createElement("nav", null,
        React.createElement("ul", { className: styles.paginationList },
            React.createElement("li", null,
                React.createElement(Button, { type: "secondary", icon: IconID.CHEVRON_LEFT, size: "s", isDisabled: activePage === 1, onClick: () => {
                        if (onActivePageChange &&
                            activePage &&
                            activePage !== 1) {
                            onActivePageChange(activePage - 1);
                        }
                    } })),
            pages.map((number) => (React.createElement("li", { key: number, onClick: () => {
                    if (onActivePageChange && number !== ELLIPSIS) {
                        onActivePageChange(number);
                    }
                }, onKeyDown: (event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        if (onActivePageChange && number !== ELLIPSIS) {
                            onActivePageChange(number);
                        }
                    }
                }, 
                // eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role
                role: "button", tabIndex: number === ELLIPSIS ? -1 : 0, "aria-current": number === activePage, className: cx({
                    [styles.page]: true,
                    [styles.activePage]: number === activePage,
                    [styles.pageButton]: number !== ELLIPSIS,
                }) }, number))),
            React.createElement("li", { className: styles.page },
                React.createElement(Button, { type: "secondary", icon: IconID.CHEVRON_RIGHT, size: "s", isDisabled: activePage === totalPages, onClick: () => {
                        if (onActivePageChange &&
                            activePage &&
                            activePage !== totalPages) {
                            onActivePageChange(activePage + 1);
                        }
                    } })))));
};
//# sourceMappingURL=pagination-numbers.js.map